import si from '../data/snapshot-info';

let snapshotDelete = {
  exeDelete : snapshot=>{
    let $delete = $('.ui-node-delete');
    if(!$delete.length){
      $delete = $(`<div class="ui-node-delete ui-modal">
        <span class="modal-close">&times;</span>
        <h5>type 'DELETE' to delete snapshot. There is no undo</h5>
        <input type="text" maxlength="25" placeholder="">
        <button type="button">OK</button>
      </div>`);
      $delete.find('.modal-close').click(()=>{
        $delete.hide()
      });
      $('body').append($delete);
    }else{
      $delete.find('input[type=text]').val('');
      $delete.show();
    }
    $delete.find('button').off('click').on('click', ()=>{
      ($delete.find('input[type=text]').val() === 'DELETE') && si.delete(snapshot.snapshot);
      $delete.hide();
    });
  }
}

export default snapshotDelete;



// WEBPACK FOOTER //
// ./src/scripts/ui/snapshot-delete.js